"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var use_media_query_string_hook_1 = __importDefault(require("../../hooks/use-media-query-string.hook"));
var mobile_component_1 = require("./mobile.component");
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
function useMobileView() {
    return use_media_query_string_hook_1.default(mobile_component_1.mobileBreakPointQuery);
}
exports.useMobileView = useMobileView;
function getMobileBreakpointInPixel() {
    var breakpoint = dark_theme_1.default.breakpoints.sm;
    var numberString = breakpoint.split('px');
    return parseInt(numberString[0]);
}
exports.getMobileBreakpointInPixel = getMobileBreakpointInPixel;
function incrementBreakPoint(breakpoint, incrementValue) {
    var fields = breakpoint.split('px');
    var numberString = fields[0];
    var number = +numberString;
    number = number + incrementValue;
    return number + 'px';
}
exports.incrementBreakPoint = incrementBreakPoint;
//# sourceMappingURL=responsive-util.js.map